<template>
  <div class="list">
    <Tabs></Tabs>
    <div class="listbd">
      <div class="titles">
        <span class="ttname">{{ articlesname }}</span>
      </div>
      <div class="videolist" v-if="categoryid == 83">
        <div class="boxli" v-for="(item, index) in articleslist" :key="index" @click="todetail(item.category_id, item.id)">
          <img :src="item.more.thumbnail" />
          <span class="vnames">{{ item.post_title }}</span>
        </div>
      </div>
      <div class="userlist" v-else-if="categoryid == 86">
        <div class="boxli" v-for="(item, index) in articleslist" :key="index" @click="todetail(item.category_id, item.id)">
          <span class="vnames">{{ item.post_title }}</span>
        </div>
      </div>
      <div class="ccboxlist" v-else-if="categoryid == 85">
        <div class="boxlist" v-for="(item, index) in cccatelist" :key="index">
          <div class="libox">
            <div class="cnames">【&nbsp;&nbsp;{{ item.name }}&nbsp;&nbsp;】</div>
            <span class="boxli" v-for="(child, c) in item.child.data" :key="c" @click="todetail(child.category_id, child.id)">
              <span class="names">
                <span class="slot">·</span>
                <span class="ttname">{{ child.post_title }}</span>
              </span>
              <span class="times">{{ getYearMonth(child.published_time) }}</span>
            </span>
          </div>
          <div class="pagenation" v-if="index == 0" style="margin-bottom: 20px">
            <span class="fstbtn" @click="setpagea(1)">首页</span>
            <span class="nextpage" @click="setpagea(2)">上一页</span>
            <span class="npages">{{ cpage1 }}</span>
            <span class="nextpage" @click="setpagea(3)">下一页</span>
            <span class="fstbtn" @click="setpagea(4)">末页</span>
            <span>共{{ callpages1 }}页</span>
            <span>共{{ ctotal1 }}条</span>
          </div>
          <div class="pagenation" v-else>
            <span class="fstbtn" @click="setpageb(1)">首页</span>
            <span class="nextpage" @click="setpageb(2)">上一页</span>
            <span class="npages">{{ cpage2 }}</span>
            <span class="nextpage" @click="setpageb(3)">下一页</span>
            <span class="fstbtn" @click="setpageb(4)">末页</span>
            <span>共{{ callpages2 }}页</span>
            <span>共{{ ctotal2 }}条</span>
          </div>
        </div>
      </div>
      <div class="boxlist" v-else>
        <span class="boxli" v-for="(item, index) in articleslist" :key="index" @click="todetail(item.category_id, item.id)">
          <span class="names">
            <span class="slot">·</span>
            <span class="ttname">{{ item.post_title }}</span>
          </span>
          <span class="times">{{ getYearMonth(item.published_time) }}</span>
        </span>
      </div>
      <div class="pagenation" v-if="ccshow == false">
        <span class="fstbtn" @click="setpage(1)">首页</span>
        <span class="nextpage" @click="setpage(2)">上一页</span>
        <span class="npages">{{ page }}</span>
        <span class="nextpage" @click="setpage(3)">下一页</span>
        <span class="fstbtn" @click="setpage(4)">末页</span>
        <span>共{{ allpages }}页</span>
        <span>共{{ total }}条</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/tabs.vue";

export default {
  name: "",
  props: {},
  data() {
    return {
      categoryid: "",
      articlesname: "",
      articleslist: [],
      page: 1,
      limit: 20,
      total: 0,
      cpage1: 1,
      ctotal1: 0,
      callpages1: 0,
      cpage2: 1,
      ctotal2: 0,
      callpages2: 0,
      allpages: 0,
      cccatelist: [
        { name: "", child: [] },
        { name: "", child: [] }
      ],
      ccshow: false,
      aid: "",
      bid: ""
    };
  },
  computed: {},
  created() {
    // this.getarticleslist();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newVal, oldVal) {
        this.articleslist = [];
        if (newVal.categoryid) {
          this.categoryid = newVal.categoryid;
          this.page = 1;
          this.getarticleslist();
          if (this.categoryid == 85) {
            this.ccshow = true;
            this.getarccatelist();
          } else {
            this.ccshow = false;
          }
          this.getarticlesname();
        }
      }
    }
  },
  methods: {
    setpage(i) {
      if (i == 1) {
        this.page = 1;
      }
      if (i == 2) {
        if (this.page < 2) {
          return;
        }
        this.page--;
      }
      if (i == 3) {
        if (this.page > this.allpages - 1) {
          return;
        }
        this.page++;
      }
      if (i == 4) {
        this.page = this.allpages;
      }
      this.getarticleslist();
    },
    setpagea(i) {
      if (i == 1) {
        this.cpage1 = 1;
      }
      if (i == 2) {
        if (this.cpage1 < 2) {
          return;
        }
        this.cpage1--;
      }
      if (i == 3) {
        if (this.cpage1 > this.callpages1 - 1) {
          return;
        }
        this.cpage1++;
      }
      if (i == 4) {
        this.cpage1 = this.callpages1;
      }
      this.getccarticleslista();
    },
    setpageb(i) {
      if (i == 1) {
        this.cpage2 = 1;
      }
      if (i == 2) {
        if (this.cpage2 < 2) {
          return;
        }
        this.cpage2--;
      }
      if (i == 3) {
        if (this.cpage2 > this.callpages2 - 1) {
          return;
        }
        this.cpage2++;
      }
      if (i == 4) {
        this.cpage2 = this.callpages2;
      }
      this.getccarticleslistb();
    },
    getarticlesname() {
      this.$api.get({
        url: "categories/read",
        data: {
          id: this.categoryid
        },
        success: (res) => {
          this.articlesname = res.data.name;
        }
      });
    },
    getarccatelist(e) {
      this.$api.get({
        url: "categories/categoryDown",
        data: {
          category_id: this.categoryid
        },
        success: (res) => {
          this.cccatelist[0].name = res.data[0].name;
          this.cccatelist[1].name = res.data[1].name;
          this.aid = res.data[0].id;
          this.bid = res.data[1].id;
          this.getccarticleslista();
          this.getccarticleslistb();
        }
      });
    },
    getccarticleslista() {
      this.$api.get({
        url: "articles",
        data: {
          page: this.cpage1,
          category_id: this.aid,
          limit: this.limit
        },
        success: (res) => {
          this.cccatelist[0].child = res.data.list;
          this.ctotal1 = this.cccatelist[0].child.total;
          this.callpages1 = Math.ceil(Number(this.ctotal1 / this.limit));
        }
      });
    },
    getccarticleslistb() {
      this.$api.get({
        url: "articles",
        data: {
          page: this.cpage2,
          category_id: this.bid,
          limit: this.limit
        },
        success: (res) => {
          this.cccatelist[1].child = res.data.list;
          this.ctotal2 = this.cccatelist[1].child.total;
          this.callpages2 = Math.ceil(Number(this.ctotal2 / this.limit));
        }
      });
    },
    getarticleslist() {
      this.$api.get({
        url: "articles",
        data: {
          page: this.page,
          category_id: this.categoryid,
          limit: this.limit
        },
        success: (res) => {
          this.articleslist = res.data.list.data;
          this.total = res.data.list.total;
          this.allpages = Math.ceil(Number(this.total / this.limit));
        }
      });
    },
    todetail(id, cid) {
      const routeData = this.$router.resolve({ name: "detail", query: { categoryid: id, postid: cid } });
      window.open(routeData.href, "_blank");
    },
    getYearMonth(e) {
      let year = e.toString().substr(2, 2);
      let month = e.toString().substr(5, 2);
      let day = e.toString().substr(8, 2);
      return month + "-" + day;
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;
    next(0);
  },
  components: {
    Tabs
  }
};
</script>

<style scoped lang="scss">
.ttname:hover {
  color: #b80808;
  font-weight: bold !important;
}

@media all and (max-width: 800px) {
  .list {
    margin-bottom: 80px !important;
    .listbd {
      width: 95% !important;
      padding: 10px !important;
      .titles {
        height: 45px !important;
        font-size: 18px !important;
        border-bottom: 4px solid #f9dbdd !important;
      }
      .videolist {
        margin-top: 20px;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
      }
      .boxlist {
        .cnames {
          font-size: 14px !important;
        }
        .boxli {
          font-size: 12px;
          .names {
            width: 65% !important;

            .slot {
              font-size: 14px !important;
              margin-right: 5px !important;
            }
            .ttname {
              white-space: nowrap !important;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .pagenation {
        font-size: 11px;
        .fstbtn {
          width: 30px !important;
          height: 20px !important;
        }
        .npages {
          width: 20px !important;
          height: 20px !important;
        }
        .nextpage {
          width: 40px !important;
          height: 20px !important;
        }
      }
    }
  }
}
.list {
  // height: 100vh;
  margin-bottom: 20px;
  .times {
    width: 35%;
    text-align: end;
  }
  .listbd {
    width: 1170px;
    min-height: 920px;
    margin: 0 auto;
    color: #000;
    margin-top: 20px;
    border: 1px solid #c50909;
    border-top: 3px solid #c50909;
    background: #fff8f8;
    padding: 30px;
    .ttname {
      width: 80%;
      height: 24px;
      overflow: hidden;
      white-space: nowrap !important;
      text-overflow: ellipsis;
    }
    .titles {
      width: 100%;
      color: #c50909;
      font-size: 22px;
      height: 60px;
      border-bottom: 8px solid #f9dbdd;
    }
    .videolist {
      margin-top: 20px;
      display: grid;
      justify-content: space-around;
      grid-template-columns: repeat(auto-fill, 33.333%);
      .boxli {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        cursor: pointer;
        margin-bottom: 15px;
        img {
          width: 320px;
          height: 240px;
        }
        .vnames {
          margin-top: 10px;
          width: 320px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          word-break: break-all;
          -webkit-box-orient: vertical;
        }
      }
    }
    .userlist {
      margin-top: 20px;
      display: grid;
      justify-content: space-between;
      grid-template-columns: repeat(auto-fill, 150px);
      .boxli {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
        .vnames {
          margin-top: 10px;
          width: 100%;
          display: flex;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
    .boxlist {
      margin-top: 20px;
      width: 100%;
      display: flex;
      flex-direction: column;
      .cnames {
        font-size: 20px;
        color: #ae0003;
        font-weight: bold;
      }
      .boxli {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        line-height: 30px;
        cursor: pointer;

        .names {
          display: flex;
          align-items: center;
          width: 80%;
          .slot {
            font-size: 30px;
            color: #ae0003;
            margin-right: 10px;
          }
        }
      }
    }
    .pagenation {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 40px;
      color: #ae0003;
      span {
        margin-right: 12px;
        cursor: pointer;
      }
      .fstbtn {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f9e1e2;
        width: 50px;
        height: 30px;
        border: 1px solid #ae0003;
      }
      .npages {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #ae0003;
      }
      .nextpage {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f9e1e2;
        width: 70px;
        height: 30px;
        border: 1px solid #ae0003;
      }
    }
  }
}
</style>
